// ** Redux Imports
import { createSlice } from "@reduxjs/toolkit";

const initialNavigation = () => {
  const item = "Bem vindo!";
  return item ? item : {};
};

const initialIconNavigation = () => {
  const item =
    "https://cdn-jupiter.s3.amazonaws.com/ctplus/modulos/logo-connect.png";
  return item ? item : {};
};

export const navigationSlice = createSlice({
  name: "navigationStep",
  initialState: {
    initialStep: initialNavigation(),
    iconInitialStepNavigation: initialIconNavigation(),
    secondStepNavigation: "",
    iconSecondStepNavigation: "",
    thirdStepNavigation: "",
    sessionTimer: 14.9,
  },
  reducers: {
    handleNavigation: (state, action) => {
      state.initialStep = action.payload;
    },
    handleIconInitialNavigation: (state, action) => {
      state.iconInitialStepNavigation = action.payload;
    },
    handleNavigationSecond: (state, action) => {
      state.secondStepNavigation = action.payload;
    },
    handleIconSecondStepNavigation: (state, action) => {
      state.iconSecondStepNavigation = action.payload;
    },
    handleNavigationThird: (state, action) => {
      state.thirdStepNavigation = action.payload;
    },
    handleSessionTimer: (state, action) => {
      state.sessionTimer = action.payload;
    },
  },
});

export const {
  handleNavigation,
  handleNavigationSecond,
  handleIconSecondStepNavigation,
  handleIconInitialNavigation,
  handleNavigationThird,
  handleSessionTimer,
} = navigationSlice.actions;

export default navigationSlice.reducer;
